import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import Header from './Header';
import { useRetailer } from 'utils/hooks';
import { useFTUWizard } from '../../context';
import { useStoreOnboarding } from '../../../context';
import { getCustomerPortalLink } from 'utils/methods';
import { getOnboardingStatus } from '../../utils';

export default function WizardTracker({ hideCompleted = false }) {
  const { isAdvancedMode, getStoreProperty } = useRetailer();
  const { todos, steps, visibleSteps } = useStoreOnboarding();
  const { step } = useFTUWizard();

  const isAdvancedSupported = getStoreProperty('isAdvancedSupported');
  const { isStarted, isInProgress, isCompleted } = getOnboardingStatus(
    todos,
    isAdvancedMode,
    isAdvancedSupported
  );
  const completedStepsCount = visibleSteps.findIndex(s => s.id === step);
  const customerPortalUrl = getCustomerPortalLink();

  if (hideCompleted && isCompleted) {
    return null;
  }

  return (
    <UiKit.Card isElevated>
      <Header isStarted={isStarted} isCompleted={isCompleted} />
      <If test={isInProgress}>
        <UiKit.Card.Body>
          <UiKit.Flex justify="space-between" gap={24} className={styles.row}>
            <UiKit.Title size="md" weight="normal">
              Your setup progress
            </UiKit.Title>
            <UiKit.Flex align="center" gap={8}>
              <UiKit.Progress.Ring
                value={completedStepsCount / visibleSteps.length}
              />
              <UiKit.Text>
                {completedStepsCount}/{visibleSteps.length} steps complete
              </UiKit.Text>
            </UiKit.Flex>
          </UiKit.Flex>
          <UiKit.Stepper
            variant="number"
            orientation="horizontal"
            steps={steps}
            value={step}
            className={styles.progress}
          />
        </UiKit.Card.Body>
      </If>
      <UiKit.Card.Body>
        <UiKit.Flex justify="space-between" gap={24}>
          <UiKit.Flex direction="column" gap={4}>
            <UiKit.Text size="lg" weight="bold">
              Customer Returns Portal
            </UiKit.Text>
            <UiKit.Copy value={customerPortalUrl} />
          </UiKit.Flex>
          <a href={customerPortalUrl} target="_blank" rel="noopener noreferrer">
            <UiKit.Button variant="ghost">View Portal</UiKit.Button>
          </a>
        </UiKit.Flex>
      </UiKit.Card.Body>
    </UiKit.Card>
  );
}
